import http from '../config/http';
import routes from '../config/api_routes';

export const getActivePromotion = () => http().get(routes.Promotion.getActive)